var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2572",
    "data-name": "Groupe 2572",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.085,
    height: 114.196,
    viewBox: "0 0 121.085 114.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2106",
    "data-name": "Rectangle 2106",
    width: 121.085,
    height: 114.196,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2572-2",
    "data-name": "Groupe 2572",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2965",
    "data-name": "Trac\\xE9 2965",
    d: "M121.571,6h-.01c-.02-.079-.05-.178-.069-.278a2.275,2.275,0,0,0-.149-.506,5.272,5.272,0,0,0-.516-1.249,6.993,6.993,0,0,0-.585-.932,1.845,1.845,0,0,0-.367-.416c-.119-.149-.268-.268-.387-.416-.238-.218-.486-.436-.734-.635a8.732,8.732,0,0,0-.932-.654.138.138,0,0,0-.1-.05A6,6,0,0,0,116.5.347a8.227,8.227,0,0,0-.813-.218A8.737,8.737,0,0,0,114.353,0H70.423V7.346H93.3V49.631a4.966,4.966,0,0,0,.1,1.15h-.1v32.38h21.058a7.633,7.633,0,0,0,1.338-.119,4.723,4.723,0,0,0,.813-.228,4.32,4.32,0,0,0,.972-.387,5.807,5.807,0,0,0,.545-.3,6.613,6.613,0,0,0,1.289-1c.2-.2.4-.416.595-.635a7.01,7.01,0,0,0,.922-1.3,4.088,4.088,0,0,0,.3-.635,6.759,6.759,0,0,0,.446-1.4,8.611,8.611,0,0,0,.119-1.338V7.337A8.611,8.611,0,0,0,121.571,6m-7.218,67.565a2.268,2.268,0,0,1-2.28,2.251H99.4V56.888a6.979,6.979,0,0,0,1.279.119h13.672Zm0-22.793H100.136a1.258,1.258,0,0,1-.734-1.15V32.41h14.951Zm0-26.164H100.681a6.978,6.978,0,0,0-1.279.119V7.337h12.67a2.293,2.293,0,0,1,2.28,2.28Z",
    transform: "translate(-0.604 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2966",
    "data-name": "Trac\\xE9 2966",
    d: "M0,7.337V75.824a8.61,8.61,0,0,0,.119,1.338,6.759,6.759,0,0,0,.446,1.4,4.088,4.088,0,0,0,.3.635,7.01,7.01,0,0,0,.922,1.3c.2.218.4.436.595.635a6.613,6.613,0,0,0,1.289,1,5.805,5.805,0,0,0,.545.3,4.319,4.319,0,0,0,.972.387A4.723,4.723,0,0,0,6,83.042a7.633,7.633,0,0,0,1.338.119H28.394V50.781h-.1a4.966,4.966,0,0,0,.1-1.15V7.346H81.009V0H7.337A8.737,8.737,0,0,0,6,.129a8.226,8.226,0,0,0-.813.218A6,6,0,0,0,3.966.863a.138.138,0,0,0-.1.05,8.733,8.733,0,0,0-.932.654c-.248.2-.5.416-.734.635-.119.149-.268.268-.387.416a1.844,1.844,0,0,0-.367.416,6.993,6.993,0,0,0-.585.932A5.272,5.272,0,0,0,.347,5.215,2.275,2.275,0,0,0,.2,5.721c-.02.1-.05.2-.069.278H.119A8.61,8.61,0,0,0,0,7.337m7.337,49.67H21.008a6.979,6.979,0,0,0,1.279-.119V75.814H9.617a2.268,2.268,0,0,1-2.28-2.251Zm0-24.6H22.287V49.621a1.258,1.258,0,0,1-.734,1.15H7.337Zm0-22.793a2.293,2.293,0,0,1,2.28-2.28h12.67v17.39a6.978,6.978,0,0,0-1.279-.119H7.337Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2105",
    "data-name": "Rectangle 2105",
    width: 76.511,
    height: 7.337,
    transform: "translate(22.287 75.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2967",
    "data-name": "Trac\\xE9 2967",
    d: "M79.5,37.883l-29-16.742a3.8,3.8,0,0,0-5.693,3.286V57.91A3.8,3.8,0,0,0,50.5,61.2l29-16.742a3.8,3.8,0,0,0,0-6.572",
    transform: "translate(-0.384 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2968",
    "data-name": "Trac\\xE9 2968",
    d: "M117.12,107.911H3.966a3.966,3.966,0,0,1,0-7.931H117.12a3.966,3.966,0,0,1,0,7.931",
    transform: "translate(0 -0.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2969",
    "data-name": "Trac\\xE9 2969",
    d: "M39.023,113.518a9.621,9.621,0,1,1,9.622-9.622,9.632,9.632,0,0,1-9.622,9.622",
    transform: "translate(-0.252 -0.809)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2970",
    "data-name": "Trac\\xE9 2970",
    d: "M39.011,95.749a8.134,8.134,0,1,1-8.134,8.134,8.134,8.134,0,0,1,8.134-8.134m0-2.974a11.108,11.108,0,1,0,11.108,11.108A11.12,11.12,0,0,0,39.011,92.775",
    transform: "translate(-0.239 -0.796)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.b23469e0918e3603ab745f103d2b4ac7.svg";
export { ForwardRef as ReactComponent };